export default __webpack_public_path__ + "static/mobile-59c0e5821e12728af61cbe8f85b5d146.jpg";